<script>
  import { Swiper, SwiperSlide } from "swiper/svelte";
  import { Pagination, Navigation } from "swiper";

  import GLightbox from 'glightbox';

  // Import Swiper styles
  import "swiper/css";
  import "swiper/css/pagination";
  import "swiper/css/navigation";

  export let images = [];
  export let id;

  function lightbox(node) {
		const lightbox = GLightbox({
      selector: '[data-lightbox]',
      touchNavigation: true,
      loop: false,
    });

		return {
			destroy() {
				lightbox.destroy();
			}
		};
	}

</script>
<svelte:head>
  <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/glightbox/dist/css/glightbox.min.css" />
</svelte:head>

<div use:lightbox>
  <Swiper
    slidesPerView={"auto"}
    spaceBetween={10}
    navigation
    pagination={{
      clickable: true,
      el: `#gallery-pagination-${id}`,
      renderBullet: (index, className) => {
        return `<span class="${className}" title="${index+1}"></span>`;
      },
    }}
    modules={[Pagination, Navigation]}
  >
    {#each images as img (img.id)}
    <SwiperSlide style="{`width: ${img.dim_thumb[0]}px`}">
        <a href="{img.url}?p=large" data-lightbox>
        <img src="{img.url}?p=thumb" alt="{img.name}" width="{img.dim_thumb[0]}" height="{img.dim_thumb[1]}" />
        </a>
    </SwiperSlide>
    {/each}
  </Swiper>

  <div class="gallery-pagination" id="gallery-pagination-{id}"></div>
</div>
